import { processSessionTableData, processSummaryData } from '../utils/dataUtils';
import { useGetAppDataTimeline } from '../utils/queryHooks';
import { useMemo } from 'react';

export const useTimelineOverview = ({ viewerId, clientId, interval }) => {
  const { data, isLoading: timelineLoading } = useGetAppDataTimeline(viewerId, interval, clientId);

  const { summaryData, sessionTableData } = data ?? {
    summaryData: {
      userInfoData: [],
      eventSummaryData: [],
    },
    sessionTableData: [],
  };
  const summaryDataRes = useMemo(() => processSummaryData(summaryData), [summaryData]);
  const sessionTableDataRes = useMemo(
    () => processSessionTableData(sessionTableData),
    [sessionTableData],
  );

  return {
    summaryData: summaryDataRes,
    sessionTableData: sessionTableDataRes,
    timelineLoading,
  };
};
